import { saveAs } from 'file-saver'
import { getIsInWebView } from './is-in-web-view'
import { csvParser, sendReactNativeCsvData, sendReactNativeExcelData } from './message-react-native'

export function exportToExcel(data: (string | number)[][], fileName: string): void {
  if (getIsInWebView()) {
    sendReactNativeExcelData(data, fileName)
    return
  }

  import('xlsx').then(xlsx => {
    const worksheet = xlsx.utils.aoa_to_sheet(data)
    const workbook = xlsx.utils.book_new()
    xlsx.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

    const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' })
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' })

    saveAs(blob, `${fileName}.xlsx`)
  })
}

export type CsvHeader = {
  label: string
  key: string
}

/**
 * @param headers array of column keys and their corresponding headers
 * @param csvData the rows of data as key-value pairs
 * @param fileName the desired filename (without file type suffix)
 * - test (Correct)
 * - test.csv (Wrong, function will add the suffix)
 * @param separator comma or semicolon
 */
export function exportToCsv(
  headers: CsvHeader[],
  csvData: Record<string, string | number | boolean>[],
  fileName: string,
  separator: ',' | ';'
): void {
  if (getIsInWebView()) {
    sendReactNativeCsvData(headers, csvData, separator)
    return
  }

  const parsedData = `sep=${separator}\n` + csvParser(headers, csvData, separator)
  const csvContent = 'data:text/csv;charset=utf-8,'
  saveAs(csvContent + parsedData, `${fileName}.csv`, { autoBom: true })
}
